<template>
  <div class="alert-widget-round-component">
    <div
      :style="{ backgroundColor: backgroundColor }"
      class="flex items-center w-full px-4 py-[0.625rem] rounded-sm md:rounded-md min-h-[2rem]">
      <div
        :style="{ color: textColor, textAlign: selectedTextAlign }"
        class="w-full text-sm md:text-base [&>a]:hover:text-brand-primary"
        v-html="getWidgetTextTranslation(alertText)" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { TranslatableString } from '~/types/widgets/widgetTypes'
import getWidgetTextTranslation from '~/utils/getWidgetTextTranslation'

const { backgroundColor, textColor, textAlign, alertText } = defineProps<{
  backgroundColor?: string
  textColor?: string
  textAlign?: string
  alertText?: TranslatableString
}>()

const selectedTextAlign = computed(() => {
  switch (textAlign) {
    case 'Left':
      return 'left'
    case 'Center':
      return 'center'
    case 'Right':
      return 'right'
    default:
      return 'left'
  }
})
</script>

<style lang="postcss" scoped>
.alert-widget-round-component {
  @apply flex w-full px-4 pt-2;
}
</style>
